<template>
    <div class="" v-if="items.length>0">
        <h2>Мероприятия в рамках реализации Проекта, в которых принимали участие педагоги, работающие в Проекте</h2>
        <br/>
        <table>
            <thead>
            <tr>
                <th>Название мероприятия для педагогов и воспитателей, работающих в проекте (семинары, мастер-классы и
                    т.п.)
                </th>
                <th>Организация, проводившая мероприятие</th>
                <th>Дата проведения</th>
                <th>Количество учителей и воспитателей кадетских классов</th>
            </tr>
            </thead>
            <tbody>
            <tr v-bind:key="item.id" v-for="item in items">
                <td>{{item.name}}</td>
                <td>{{item.organization}}</td>
                <td :text-content.prop="timestampToDate(item.publishDate)"></td>
                <td>{{item.numberTeachers}}</td>
            </tr>
            </tbody>
        </table>
    </div>
</template>


<script>
    import Request from 'superagent';
    import { common } from '../mixins/common';

    export default {
        mixins: [ common ],
        data() {
            return {
                items: [],
            };
        },


        created() {
            this.getItems();
        },


        methods: {
            getItems() {
                var path = this.$store.state.api + this.$store.state.apiCadetEventTeacher + "?eoId=" + this.$store.state.eoId;
                var $this = this;
                Request
                    .get(path)
                    .then((res) => {
                        if (res.status == 200) {
                            if (res.body.result == 'success') {
                                $this.items = res.body.data;
                            }
                        }
                    });
            },
        },
    }
</script>


<style>

</style>
